export const SOLUTION_REFERENCE_TYPE = Object.freeze({
    RACKSOLUTION_KIT: "racksolution_kit",
    RACKSOLUTION_FOOT: "racksolution_foot",
    RACKSOLUTION_BAR: "racksolution_bar",
    RACKSOLUTION_COMPLETE_FRONT: "racksolution_complete_front",
    RACKSOLUTION_COMPLETE_REAR: "racksolution_complete_rear",
    RACKSOLUTION_COMPLETE: "racksolution_complete",
    SOLUTION_ADAPTER: "solution_adapter",
    PLATFORM: "platform",
    RACKSOLUTION_BASERAIL: "racksolution_baserail",
    RACKSOLUTION_OVERHEADRACK: "racksolution_overheadrack",
    RACKSOLUTION_TOWER: "racksolution_tower"
});

export const retailerFitGuide_storageKey = "retailerFitGuide_productList";

export const TRACK_EVENT_TYPE = Object.freeze({
    CARFIT: "carfit",
    REFIT: "refit",
    PRODUCTLIST: "productList",
    COMPATIBLEPRODUCTS: "compatibleProducts",
    INSTRUCTIONS: "instructions",
});

export const FILTERED_SOLUTION_TYPES = [
    "Roof rack", "Truck rack", "Roof Platform"
]